import { render, staticRenderFns } from "./TransmitterShow.vue?vue&type=template&id=bbe53f4e&scoped=true&"
import script from "./TransmitterShow.vue?vue&type=script&lang=js&"
export * from "./TransmitterShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe53f4e",
  null
  
)

export default component.exports